module.exports = __webpack_public_path__ + "static/media/mushroommovie_dance.4207023d.gif";